import { render, staticRenderFns } from "./custom-component-common.vue?vue&type=template&id=0aa4f71f&scoped=true&"
import script from "./custom-component-common.vue?vue&type=script&lang=js&"
export * from "./custom-component-common.vue?vue&type=script&lang=js&"
import style0 from "./custom-component-common.vue?vue&type=style&index=0&id=0aa4f71f&scoped=true&lang=scss&"
import style1 from "./custom-component-common.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa4f71f",
  null
  
)

export default component.exports